<template>
<section id="projects">
  <div class="container">
    <carousel
      :perPageCustom="[
        [0, 1],
        [768, 2],
        [992, 3],
        [1200, 4],
      ]"
      :paginationEnabled="false"
      :navigationEnabled="true"
      navigationNextLabel="▶&#xFE0E;"
      navigationPrevLabel="◀&#xFE0E;">
      <slide v-for="(project, index) in projects" :key="index">
        <card :imgURL="project.icon" :modalData="project">
          {{project.title}} <span>{{project.tech}}</span>
        </card>
      </slide>
    </carousel>
  </div>
</section>
</template>

<script>
import projects from '@/Bus';
import Card from './Card';

export default {
  name: 'Projects',
  components: {
    Card,
  },
  data() {
    return {
      projects,
    };
  },
};
</script>

<style lang="scss">
#projects {
  padding: 10px 0 50px;
  .container {
    .VueCarousel {
      //max-width: 85%;
      .VueCarousel-inner {
        justify-content: center;
      }
      .VueCarousel-slide {
        padding: 0 5px;
      }
      .VueCarousel-navigation-button {
        color: $text_gray;
        font-size: 60px;
        text-shadow: 0 3px 6px rgba(#000, .35);
        transition: all .2s ease;
        padding: 0 !important;
        &.VueCarousel-navigation--disabled {
          text-shadow: none;
          opacity: 0;
        }
      }
    }
    .cardgrid {
      display: grid;
    }
  }
}

@media screen and (max-width: 500px) {
  #projects {
    .container {
      .VueCarousel {
        .VueCarousel-inner {
          justify-content: flex-start !important;
        }
        .VueCarousel-navigation-button {
          padding: 0 !important;
          font-size: 40px;
        }
      }
    }
  }
}

@media (max-width: 594px) {
  #projects {
    .container {
      overflow: hidden;
      .VueCarousel {
        width: 80%;
        margin: 0 auto;
        max-width: 80%;
        .VueCarousel-inner {
          justify-content: flex-start !important;
        }
        .VueCarousel-navigation-button {
          padding: 0 !important;
        }
        .VueCarousel-slide {
          padding: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  #projects {
    .container {
      //overflow: hidden;
      .VueCarousel {
        margin: 0 auto;
        width: 80%;
        max-width: 80%;
        .VueCarousel-inner {
          justify-content: flex-start !important;
        }
      }
    }
  }
}

@media screen and (max-width: 991px) {
  #projects {
    .container {
      //overflow: hidden;
      .VueCarousel {
        margin: 0 auto;
        width: 95%;
        .VueCarousel-inner {
          justify-content: flex-start !important;
        }
      }
    }
  }
}

@media screen and (max-width: 1300px) {
  #projects {
    .container {
      //overflow: hidden;
      .VueCarousel {
        margin: 0 auto;
        width: 90%;
        .VueCarousel-inner {
          justify-content: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/Projects.vue